export const CONFIG_REQUESTED = "CONFIG_REQUESTED";
export const CONFIG_RECEIVED = "CONFIG_RECEIVED";
export const CONFIG_REQUEST_FAILED = "CONFIG_REQUEST_FAILED";

export const requestConfig = () => ({ type: CONFIG_REQUESTED });
export const receiveConfig = () => ({ type: CONFIG_RECEIVED });
